/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { FontIcon } from 'material-ui'

import { TextField, DatePicker } from 'generic/form'
import * as constants from 'constants/Prestation'

class AdditionalServiceSearch extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)

    this.state = {
      prestationSearchAutocomplete: [],
      languages: [],
      autocompleteText: undefined,
      errors: {},
    }
  }

  handleSetDateRef(field) {
    this.datePicker = field || null
  }

  handleChange(event, value) {
    new Promise((resolve, reject) => {
      this.props.handlePrestationChange(event.target.name, value)
      resolve()
    })
    .then(() => {
      this.props.handleShowDetails()
    })
  }

  handleBlur(event, value) {
    new Promise((resolve, reject) => {
      this.props.handlePrestationChange(event.target.name, Math.ceil(event.target.value / 5) * 5)
      resolve()
    })
  }

  handleDateFormatChange(event, value) {
    new Promise((resolve, reject) => {
      this.props.handleDateFormatChange(event.target.name, value)
      resolve()
    })
    .then(() => {
      this.props.handleShowDetails()
    })
  }

  handleDateChange(event, value) {
    new Promise((resolve, reject) => {
      this.props.handleDateChange(event.target.name, value)
      resolve()
    })
    .then(() => {
      this.props.handleShowDetails()
    })
  }

  render() {
    const prestation = this.props.prestation
    const meta = prestation && prestation.meta ? prestation.meta.fields : {}
    const orderedDate = prestation &&
                        prestation.ordered_date &&
                        prestation.ordered_date.length === 10
                          ? moment(prestation.ordered_date).format('DD.MM.YYYY')
                          : prestation &&
                            prestation.ordered_date
                            ? prestation.ordered_date
                            : undefined

    return (
      <React.Fragment>
        <div
          className='col-md-2 col-xs-12'
          style={{position: 'relative'}}
        >
          <TextField
            name='ordered_date'
            meta={meta.ordered_end_time}
            disabled={!!prestation.uid}
            value={orderedDate}
            floatingLabelText={this.props.intl.formatMessage(constants.messages.DATE_LABEL)}
            onChange={this.handleDateFormatChange}
            mask='99.99.9999'
            style={styles.fontText}
            errorText={this.props.errors ? this.props.errors.ordered_date : undefined}
            placeholderMandatory={true}
          />

          <DatePicker
            name='ordered_date'
            divStyle={{display: 'none'}}
            locale={this.props.intl.locale}
            onChange={this.handleDateChange}
            getField={this.handleSetDateRef}
          />

          {
            !prestation.uid
              ? <FontIcon
                onClick={() => this.datePicker.focus()}
                className='material-icons'
                style={{
                  margin: '20px 5px 0 0',
                  top: 20,
                  right: 0,
                  position: 'absolute',
                  cursor: 'pointer'
                }}
              >today
              </FontIcon>
              : undefined
          }
        </div>

        <div
          className='col-md-3 col-xs-12'
          style={{position: 'relative'}}
        >
          <TextField
            meta={{mandatory: true}}
            name='additional_services'
            disabled={!!prestation.uid}
            placeholderMandatory={true}
            value={prestation.additional_services}
            floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_THREE_ADDITIONNAL_SERVICES_LABEL)}
            errorText={prestation.errors ? prestation.errors.additional_services : undefined}
            floatingLabelStyle={styles.fontText}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
          />
        </div>
      </React.Fragment>
    )
  }
}

const styles = {
  fontText: {
    fontSize: 14
  },
}

export default injectIntl(AdditionalServiceSearch)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/search/AdditionalServiceSearch.js